import React from 'react';
import { StyleSheet } from 'react-native';
import {
  DNABox,
  DNAButton,
  DNACollapsibleActionMenu,
  DNACollapsibleCard,
} from '@alucio/lux-ui';
import DNADocumentSummaryContent from './DNADocumentSummaryContent';

interface DNAAISummaryProps {
  summary?: string;
  onEdit?: () => void;
}

interface DocumentSummaryData {
  documentSummary?: string;
  longSummary?: string | null;
  shortSummary?: string | null;
}

export const getDocumentSummary = <T extends DocumentSummaryData>(
  contentPageData?: T[],
): string | undefined => contentPageData?.find(page => page.shortSummary != null)?.shortSummary ?? undefined;

export const getDocumentDisplaySummary = <T extends DocumentSummaryData>(
  contentPageData?: T[],
  versionShortSummary?: string | null,
): string | undefined => versionShortSummary ??
  getDocumentSummary(contentPageData) ??
  undefined;

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
});

const DNAAISummary: React.FC<DNAAISummaryProps> = ({ summary, onEdit }) => {
  if ((summary === undefined || summary === '') && !onEdit) return null;

  return (
    <DNABox appearance="col" style={styles.container}>
      <DNACollapsibleCard
        collapseButtonSize="sm"
        collapsedDefault={false}
        headerTitle="AI Summary"
      >
        {onEdit && (
          <DNACollapsibleActionMenu>
            <DNAButton appearance="ghost" status="tertiary" onPress={onEdit}>
              Edit
            </DNAButton>
          </DNACollapsibleActionMenu>
        )}
        {summary && (
          <DNADocumentSummaryContent summary={summary} />
        )}
      </DNACollapsibleCard>
    </DNABox>
  );
};

export default DNAAISummary;
